import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import { getPrintImage } from '../shared/logic/get-print-image';
import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';
import { ViewProps } from './image-sphere.constants';
import { ImageContainer } from '../image/image.style';
import { ImageViewFill } from '../image/image-print';

const ImageSpherePrint = ({
  properties: { altText, printImageUrls, dimensionData },
}: ViewProps) => {
  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper>
        <ImageContainer $fullBorderRadius>
          <ImageViewFill
            imageUrl={getPrintImage(printImageUrls)}
            altText={altText}
          />
        </ImageContainer>
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};
export default ImageSpherePrint;
